export const iconFontAwesomeHumanitarianPersonChalkboard = (
	<i className="fa-solid fa-person-chalkboard"></i>
);
